import { zipcode_regex, phone_regex } from "./index";

export function stringIsNullOrEmpty(str: string): boolean {
    return str === undefined || str === null || str.length === 0;
}

export function isValidPhoneNumber(number: string): boolean {
    if (!number)
        return false;
    return phone_regex.test(number);
}

export function isValidZipCode(zipCode: string): boolean {
    if (!zipCode)
        return false;
    return zipcode_regex.test(zipCode);
}


// WEBPACK FOOTER //
// ./app/helpers/validity.ts